import { useGetAllLocations } from "@/locations/api/queries/location.queries.ts";
import SkeletonPage from "@/shared/components/skeleton/page/skeleton-page.tsx";
import PageContent from "@/shared/components/layout/dashboard-layout/page-content.tsx";
import LocationCard from "@/locations/components/common/location-card/location-card.tsx";
import { useOrganizationStore } from "@/shared/stores/useOrganizationStore.ts";
import { useGetOrganizationById } from "@/auth/api/queries/user.queries.ts";
import { MACHINES_URL } from "@/machines/routes.ts";
import { useSetBreadcrumbs } from "@/shared/contexts/breadcrumb-context";
import { useTranslation } from "react-i18next";

const Locations = () => {

  const { t } = useTranslation("locations");
  const { data: locations, isPending } = useGetAllLocations();
  const { selectedOrganizationId } = useOrganizationStore();
  const { data: orgData, isLoading: isOrgLoading } = useGetOrganizationById(selectedOrganizationId!);

  // Set breadcrumbs using the hook
  useSetBreadcrumbs([
    {
      path: MACHINES_URL.LOCATION,
      breadcrumb: orgData?.data?.name || t("breadcrumbs.organization"),
      type: "organizations",
      currentId: selectedOrganizationId!,
      isLoading: isOrgLoading
    },
  ]);

  if (isPending) {
    return <SkeletonPage />
  }

  return (
    <>
      <PageContent>
        <div className={"flex flex-col gap-8"}>
          <div className={"grid xl:grid-cols-3 md:grid-cols-2 gap-4"}>
            {locations?.data?.map((location) => {
              return <LocationCard location={location} key={location.id} />
            })}
          </div>
        </div>
      </PageContent>
    </>
  )

}

export default Locations;